import { singleSelectionOptions } from 'src/components/helpers';

export const prestadores_evaluacion_questions = (inputs = {}) => [
  {
    type: 'title',
    text: 'Evaluación para prestadores de servicio',
    class: 'section-title',
  },
  {
    type: 'richText',
    text: 'Hola 👋\n\nEn Comunidad MDE valoramos profundamente el servicio que prestas y el aporte que haces para que más personas puedan conocer y experimentar el amor de Dios. Por eso, queremos escucharte y también darte un espacio para que puedas evaluarte y compartir cómo te has sentido.',
    class: 'intro-text',
    textOnlyInQuestions: true,
  },
  {
    type: 'richText',
    text: 'Te invitamos a diligenciar esta **evaluación para prestadores de servicio**, que tiene tres partes principales:\n\n 1. **Autoevaluación de tu servicio y compromiso**  Cómo percibes la forma en que estás desarrollando la prestación de tu servicio en Comunidad MDE.\n\n 2. **Alineación entre tu contrato y las actividades que realizas**  Si lo que haces en el día a día corresponde a lo que se pactó en tu contrato, o si sientes que hay tareas por fuera de ese alcance.\n\n 3. **Coordinación del servicio, ambiente de colaboración y cultura**  Cómo te sientes con la forma en que se coordina y acompaña la prestación de tu servicio, el ambiente de colaboración en el espacio donde sirves y la cultura de Comunidad MDE.',
    class: 'intro-text',
    textOnlyInQuestions: true,
  },
  {
    type: 'title',
    text: '¿Cómo completar la evaluación?',
    class: 'section-subtitle',
    textOnlyInQuestions: true,
  },
  {
    type: 'richText',
    text: 'Encontrarás varias afirmaciones donde te pedimos marcar **cuánto estás de acuerdo**, usando la siguiente escala:\n\n **1 Totalmente en desacuerdo**\n **2 En desacuerdo**\n **3 Ni de acuerdo ni en desacuerdo**\n **4 De acuerdo**\n **5 Totalmente de acuerdo**\n\nTambién encontrarás algunas **preguntas abiertas** para que puedas expresar con tus propias palabras lo que piensas o sientes.',
    class: 'intro-instructions',
    textOnlyInQuestions: true,
  },
  {
    type: 'text',
    text: 'Completarla te tomará aproximadamente 10–15 minutos.',
    class: 'intro-text',
    textOnlyInQuestions: true,
  },
  {
    type: 'title',
    text: '¿Para qué usaremos esta información?',
    class: 'section-subtitle',
    textOnlyInQuestions: true,
  },
  {
    type: 'richText',
    text: '- Para escucharte y entender mejor tu experiencia como prestador de servicio en Comunidad MDE.\n- Para identificar fortalezas y también áreas donde podamos mejorar procesos, liderazgo, comunicación y organización.\n- Para tomar decisiones que nos ayuden a cuidar mejor a las personas que sirven desde la modalidad de prestación de servicios.',
    class: 'intro-text',
    textOnlyInQuestions: true,
  },
  {
    type: 'richText',
    text: 'Esta evaluación **no es un examen** para juzgarte ni para sancionar a nadie. Es una herramienta para mejorar juntos y seguir construyendo una cultura sana, alineada con nuestros valores: **amor, excelencia, presencia de Dios y amabilidad**.\n\nTus respuestas serán tratadas con **confidencialidad**. La información se analizará de forma conjunta y, cuando sea necesario revisar algún caso puntual, se hará con respeto y procurando siempre el bienestar de las personas y de la iglesia.',
    class: 'intro-instructions',
    textOnlyInQuestions: true,
  },
  {
    type: 'richText',
    text: 'Agradecemos mucho tu sinceridad y el tiempo que dedicarás a responder.\n\nTu voz es importante para nosotros 💙',
    class: 'intro-closing',
    textOnlyInQuestions: true,
  },
  {
    type: 'title',
    text: 'SECCIÓN 0 – Datos generales',
    class: 'section-title',
  },
  {
    type: 'checkbox',
    id: 'area',
    text: 'Área en la que prestas servicio:',
    multiple: true,
    options: [
      'Comunicaciones',
      'Producción',
      'Music',
      'Experiencia',
      'Generaciones',
      'Administración / Contabilidad',
      'Fundación',
      'Otra',
    ],
  },
  {
    type: 'input',
    id: 'area_otra',
    text: 'Si seleccionaste "Otra", especifica:',
    kind: 'text',
    notMandatory: !inputs.area?.includes('Otra'),
  },
  {
    type: 'select',
    id: 'tiempo_servicio',
    text: 'Tiempo prestando servicio a Comunidad MDE:',
    options: ['Menos de 6 meses', '6–12 meses', '1–3 años', 'Más de 3 años'],
  },

  // Section 1 - Autoevaluación
  {
    type: 'title',
    text: 'SECCIÓN 1 – Autoevaluación de tu servicio y compromiso',
    class: 'section-title',
  },
  {
    type: 'text',
    text: 'Marca tu nivel de acuerdo con las siguientes afirmaciones:',
  },
  {
    type: 'select',
    id: 'q1',
    text: '1. Conozco con claridad las actividades principales y el alcance por los cuales fui contratado/a para prestar mi servicio en Comunidad MDE.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q2',
    text: '2. Considero que estoy cumpliendo de manera responsable y oportuna con las actividades pactadas para la prestación de mi servicio.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q3',
    text: '3. Entrego los resultados de mi servicio con un nivel de calidad y excelencia consistente con lo que se espera en Comunidad MDE.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q4',
    text: '4. Siento que doy lo mejor de mí en el servicio que presto, no solo a nivel técnico sino también en actitud.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q5',
    text: '5. Cumplo con los plazos y compromisos acordados para la prestación de mi servicio.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q6',
    text: '6. Me esfuerzo por proponer mejoras o ideas que aporten al espacio de servicio y a la iglesia, más allá de lo mínimo requerido.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q7',
    text: '7. Recibo y aprovecho la retroalimentación (feedback) para mejorar la forma en que presto mi servicio.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q8',
    text: '8. Siento que mis dones, habilidades y experiencia están siendo bien utilizados en el servicio que presto en Comunidad MDE.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'textArea',
    id: 'q9',
    text: '9. Desde tu perspectiva, ¿cuáles han sido tus principales aportes o logros en Comunidad MDE en los últimos meses?',
  },
  {
    type: 'textArea',
    id: 'q10',
    text: '10. ¿En qué aspectos de tu servicio consideras que podrías mejorar? ¿Qué necesitarías para lograrlo?',
  },

  // Section 2 - Alineación contrato
  {
    type: 'title',
    text: 'SECCIÓN 2 – Alineación entre el contrato y las actividades reales',
    class: 'section-title',
  },
  {
    type: 'text',
    text: 'Marca tu nivel de acuerdo con las siguientes afirmaciones:',
  },
  {
    type: 'select',
    id: 'q11',
    text: '11. Tengo claridad sobre el alcance del contrato de prestación de servicios que firmé con Comunidad MDE.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q12',
    text: '12. Las actividades que realizo habitualmente corresponden, en su mayoría, a lo que está descrito en mi contrato.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q13',
    text: '13. Cuando se me pide realizar actividades adicionales o diferentes, se me comunica de manera clara y con sentido.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q14',
    text: '14. No siento que se me esté solicitando de forma habitual tareas que exceden de manera injusta el alcance de mi contrato.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q15',
    text: '15. Considero que la carga de trabajo que tengo es razonable para el tipo de contrato y el tiempo pactado.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q16',
    text: '16. Si en algún momento siento que una actividad solicitada no corresponde a mi contrato, me siento con libertad para expresarlo.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'textArea',
    id: 'q17',
    text: '17. Menciona hasta tres actividades que realices con frecuencia y que consideras que no están claramente contempladas en tu contrato (si no hay, escribe "no aplica").',
  },
  {
    type: 'textArea',
    id: 'q18',
    text: '18. En tus propias palabras, ¿qué tan alineado sientes tu dinámica en la prestación del servicio con lo que pactaste al inicio de tu contrato?',
  },
  {
    type: 'textArea',
    id: 'q19',
    text: '19. Si pudieras ajustar algo en la definición de tu rol o en las actividades pactadas para tu servicio, ¿qué cambiarías y por qué?',
  },

  // Section 3 - Coordinación
  {
    type: 'title',
    text: 'SECCIÓN 3 – Coordinación del servicio, ambiente de colaboración y cultura',
    class: 'section-title',
  },
  {
    type: 'text',
    text: 'Marca tu nivel de acuerdo con las siguientes afirmaciones:',
  },
  {
    type: 'select',
    id: 'q20',
    text: '20. La persona con la que coordino la prestación de mi servicio comunica con claridad las expectativas sobre las actividades pactadas.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q21',
    text: '21. Siento que la persona con la que coordino la prestación de mi servicio me escucha y toma en cuenta mi opinión cuando hay temas que me afectan.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q22',
    text: '22. Recibo retroalimentación de las personas con quienes coordino la prestación de mi servicio con una frecuencia adecuada y en un tono respetuoso y constructivo.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q23',
    text: '23. Siento que se me trata con respeto y dignidad, tanto por las personas con quienes coordino la prestación de mi servicio como por las demás personas con quienes interactúo en el desarrollo de mi servicio.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q24',
    text: '24. Percibo que las personas con quienes coordino la prestación de mi servicio modelan los valores de Comunidad MDE (amor, excelencia, presencia de Dios y amabilidad) en la forma en que se relacionan.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q25',
    text: '25. El ambiente de colaboración en el espacio donde presto mi servicio es sano: hay cooperación, buen trato y se manejan bien los conflictos.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q26',
    text: '26. Cuando hay conflictos o tensiones relacionados con la prestación de mi servicio, se abordan de manera respetuosa y orientada a soluciones.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q27',
    text: '27. Siento que mi bienestar (emocional, espiritual y personal) es importante para la iglesia como institución.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q28',
    text: '28. En general, me siento satisfecho/a con la forma en que se coordina y acompaña la prestación de mi servicio en Comunidad MDE.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q29',
    text: '29. En general, me siento satisfecho/a con el ambiente de colaboración y la cultura que se vive en Comunidad MDE en relación con la prestación de mi servicio.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'textArea',
    id: 'q30',
    text: '30. ¿Qué es lo que más valoras de la forma en que se coordina y acompaña tu servicio, y del ambiente de colaboración en Comunidad MDE?',
  },
  {
    type: 'textArea',
    id: 'q31',
    text: '31. Si pudieras cambiar o mejorar algo en la forma en que se coordinan los servicios o en el ambiente de colaboración, ¿qué sería?',
  },
  {
    type: 'textArea',
    id: 'q32',
    text: '32. ¿Hay algo que quisieras expresar a la iglesia como institución respecto a cómo se cuida a las personas que prestan servicio (positiva o constructivamente)?',
  },

  // Section 4 - Cierre
  {
    type: 'title',
    text: 'SECCIÓN 4 – Cierre',
    class: 'section-title',
  },
  {
    type: 'textArea',
    id: 'q33',
    text: '33. En una frase, ¿cómo describirías tu experiencia prestando servicio a Comunidad MDE?',
  },

  {
    type: 'send',
    text: 'Enviar',
    class: 'send-button',
  },
];
